import Evidence from '../evidence';

/**
 * Create the action
 */

const { thunk, request, success, error } = Evidence.update((data, fetch) =>
  fetch.post(`/portfolio-evidence/${data.id}`, {
    ...data,
    _method: 'put',
  })
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
